import {Button, HStack} from '@chakra-ui/react';
import {SUPPORT_PHONE_NUMBER} from 'config';
import {FC} from 'react';
import {TranslationKeys} from 'translations';
import ImageUI from 'ui/ImageUI';

import {CallBtn} from './components';

interface IProps {
  t: (term: TranslationKeys) => string;
}

export const SupportButtons: FC<IProps> = ({t}) => {
  return (
    <HStack>
      <Button
        as="a"
        variant="outline"
        href="https://tawk.to/chat/5799cb9f8642ec804b784810/default"
        leftIcon={<ImageUI src="/icons/message-circle.svg" alt="Chat" />}
      >
        {t('CHAT')}
      </Button>
      <CallBtn innerTitle={t('SOUNDS')} t={t} phoneNumber={SUPPORT_PHONE_NUMBER} />
    </HStack>
  );
};
